interface CircularRefreshIconProps {
  width?: string;
  height?: string;
  fill?: string;
  onClick?: () => void;
  className?: string;
}
const CircularRefreshIcon = (props: CircularRefreshIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      onClick={props.onClick}
      className={props.className}
    >
      <path
        d="M8.00065 13.6664C11.1303 13.6664 13.6673 11.1294 13.6673 7.99974C13.6673 6.11605 12.7482 4.44703 11.334 3.41667M8.66732 14.9331L7.33398 13.5997L8.66732 12.2664M8.00065 2.33307C4.87104 2.33307 2.33398 4.87013 2.33398 7.99974C2.33398 9.88343 3.25309 11.5525 4.66732 12.5828M7.33398 3.73307L8.66732 2.39974L7.33398 1.06641"
        stroke={props.fill || "#5C5C5C"}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CircularRefreshIcon;
